import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { AiOutlineFileExcel } from "react-icons/ai";
import { IoExitOutline } from "react-icons/io5";
import { API_HOST } from "../../api_utils";
import axios from "axios";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";

function CashFlow(props) {
  let navigate = useNavigate();
  const { userDataFromStorage, coloredTheme } = props;

  const [cashFlowList, setCashFlowList] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [currentData1, setCurrentData1] = useState([]);
  const [currentData2, setCurrentData2] = useState([]);
  const [currentData3, setCurrentData3] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  // STATES FOR PAGINATION:
  const [page, setPage] = useState(1);
  const rowsPerPage = 20;
  const [totalPages, setTotalPages] = useState(0);

  // states for filter:
  const [filterData, setFilterData] = useState([]);
  const [managerName, setManagerName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentRole, setAgentRole] = useState("");
  const [reportDateAfter, setReportDateAfter] = useState("");
  const [reportDateBefore, setReportDateBefore] = useState("");
  const [managerNameList, setManagerNameList] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);
  const [reportDate, setReportDate] = useState(null);

  const [totalStartingCashInHand, setTotalStartingCashInHand] = useState(0);
  const [totalCashIn1, setTotalCashIn1] = useState(0);
  const [totalCashOut1, setTotalCashOut1] = useState(0);
  const [totalClaims1, setTotalClaims1] = useState(0);
  const [totalFinalCash1, setTotalFinalCash1] = useState(0);
  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [managerNameForApi, setManagerNameForApi] = useState("");
  const [selectedManagerName, setSelectedManagerName] = useState("");

  const [loading, setLoading] = useState(false);

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });
  const [reportEndDate, setReportEndDate] = useState(
    formatDate(currentDateInSingapore)
  );

  const [overallPaginatedData, setOverallPaginatedData] = useState([]);

  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  console.log("reportEndDate:::::", reportEndDate);

  const searchFilterOptionsShow = useRef(true);

  const managerRelatedUserFetch = async (agent) => {
    console.log("here123:::::::::");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/transaction_user_relation`;

    const { data } = await axios.get(apiUrl, config);
    console.log("data here ::::::::", data);
    if (data) {
      if (!data.message) {
        setLoading(false);
        console.log("data::::::", data);
        // setCashLoanModelData(data);
        setAllUsers(data);
      }
    }
  };

  const getAllManagerNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/manager_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setManagerNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getCnnyStartDateHandler = async () => {
    const { data } = await axios.get(
      `${API_HOST}/api/users/get_cnny_start_date_report`
    );
    if (data) {
      if (!data.message) {
        console.log("data::::", data);
        setReportDate(
          new Date(data[0].cn_ny_start).toISOString().split("T")[0]
        );
      }
    }
  };

  const getCashInHandler = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let currentPage = 1;
    let pageSize = 20;

    let apiUrl = `${API_HOST}/api/users/get_cash_in_cash_flow?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (reportEndDate) {
      queryParams.push(`report_end_date=${reportEndDate}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData(data);
      }
    }
  };

  const getCashOutHandler = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let currentPage = 1;
    let pageSize = 20;

    let apiUrl = `${API_HOST}/api/users/get_cash_out_cash_flow?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (reportEndDate) {
      queryParams.push(`report_end_date=${reportEndDate}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData1(data);
      }
    }
  };

  const getClaimHandler = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let currentPage = 1;
    let pageSize = 20;

    let apiUrl = `${API_HOST}/api/users/get_claim_cash_flow?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (reportEndDate) {
      queryParams.push(`report_end_date=${reportEndDate}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData2(data);
      }
    }
  };

  const getCashStartHandler = async () => {
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let currentPage = 1;
    let pageSize = 20;

    let apiUrl = `${API_HOST}/api/users/get_cash_start_cash_flow?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (reportDate) {
      queryParams.push(`report_date=${reportDate}`);
    }

    if (reportEndDate) {
      queryParams.push(`report_end_date=${reportEndDate}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }
    setLoading(true);

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        setLoading(false);
        setCurrentData3(data);
      }
    }
  };

  useEffect(() => {
    getCnnyStartDateHandler();
  }, []);

  useEffect(() => {
    managerRelatedUserFetch();
    getAllAgentNames();
    getAllManagerNames();
    if (reportDate && reportEndDate) {
      getCashInHandler();
      getCashOutHandler();
      getClaimHandler();
      getCashStartHandler();
    }
  }, [reportEndDate, reportDate, managerNameForApi, agentNameForApi]);

  useEffect(() => {
    if (allUsers.length) {
      async function fetchData() {
        let totalStartingCash = 0;
        let totalCashIn = 0;
        let totalCashOut = 0;
        let totalClaims = 0;

        if (agentNameForApi) {
        }
        let combinedArray = [];

        if (agentNameForApi) {
          let userDetail = allUsers.filter(
            (x) => x.last_name === agentNameForApi
          );
          combinedArray = await Promise.all(
            userDetail.map((item1) => {
              const matchingItem1 =
                currentData.find(
                  (item2) => item2._id === item1.employee_number
                ) || {};
              const matchingItem2 =
                currentData1.find(
                  (item3) => item3._id === item1.employee_number
                ) || {};
              const matchingItem3 =
                currentData2.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};
              const matchingItem4 =
                currentData3.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};

              totalStartingCash += matchingItem4.cash_in_hand
                ? matchingItem4.cash_in_hand
                : 0;
              totalCashIn += matchingItem1.cash_collected
                ? matchingItem1.cash_collected
                : 0;
              totalCashOut += matchingItem2.cash_loaned
                ? matchingItem2.cash_loaned
                : 0;
              totalClaims += matchingItem3.claims ? matchingItem3.claims : 0;

              let cashInNew = matchingItem1.cash_collected || 0;
              let cashInHandNew = matchingItem4.cash_in_hand || 0;
              let cashOutNew = matchingItem2.cash_loaned || 0;
              let claimNew = matchingItem3.claims || 0;

              return {
                _id: item1.employee_number,
                cash_in: matchingItem1.cash_collected || "---",
                cash_out: matchingItem2.cash_loaned || "---",
                claims: matchingItem3.claims || "---",
                cash_start_date: matchingItem4.cash_in_hand_date || 0,
                cash_in_hand: matchingItem4.cash_in_hand || "---",
                agent_name: item1.agent_name || item1.last_name,
                manager_name: item1.managerName ? item1.managerName : "",
                cash_final:
                  parseFloat(cashInHandNew) +
                  parseFloat(cashInNew) -
                  parseFloat(cashOutNew) -
                  parseFloat(claimNew),
              };
            })
          );
        } else {
          combinedArray = await Promise.all(
            (combinedArray = allUsers.map(async (item1) => {
              console.log("item1:::", item1);

              const matchingItem1 =
                currentData.find(
                  (item2) => item2._id === item1.employee_number
                ) || {};
              const matchingItem2 =
                currentData1.find(
                  (item3) => item3._id === item1.employee_number
                ) || {};
              const matchingItem3 =
                currentData2.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};
              const matchingItem4 =
                currentData3.find(
                  (item4) => item4._id === item1.employee_number
                ) || {};

              totalStartingCash += matchingItem4.cash_in_hand
                ? matchingItem4.cash_in_hand
                : 0;
              totalCashIn += matchingItem1.cash_collected
                ? matchingItem1.cash_collected
                : 0;
              totalCashOut += matchingItem2.cash_loaned
                ? matchingItem2.cash_loaned
                : 0;
              totalClaims += matchingItem3.claims ? matchingItem3.claims : 0;

              let cashInNew = matchingItem1.cash_collected || 0;
              let cashInHandNew = matchingItem4.cash_in_hand || 0;
              let cashOutNew = matchingItem2.cash_loaned || 0;
              let claimNew = matchingItem3.claims || 0;

              return {
                _id: item1.employee_number,
                cash_in: matchingItem1.cash_collected || "---",
                cash_out: matchingItem2.cash_loaned || "---",
                claims: matchingItem3.claims || "---",
                cash_start_date: matchingItem4.cash_in_hand_date || 0,
                cash_in_hand: matchingItem4.cash_in_hand || "---",
                agent_name: item1.agent_name || item1.last_name,
                manager_name: item1.managerName ? item1.managerName : "",
                cash_final:
                  parseFloat(cashInHandNew) +
                  parseFloat(cashInNew) -
                  parseFloat(cashOutNew) -
                  parseFloat(claimNew),
              };
            }))
          );
        }

        console.log("flattenedArray", combinedArray);
        console.log("totalStartingCash", totalStartingCash);
        console.log("totalCashIn", totalCashIn);
        console.log("totalCashOut", totalCashOut);
        console.log("totalClaims", totalClaims);

        setTotalStartingCashInHand(totalStartingCash);
        setTotalCashIn1(totalCashIn);
        setTotalCashOut1(totalCashOut);
        setTotalClaims1(totalClaims);
        // setTotalStartingCashInHand(totalStartingCash)

        let totalFinalCash =
          totalStartingCash + totalCashIn - totalCashOut - totalClaims;

        setTotalFinalCash1(totalFinalCash);

        let combinedArrayNew = combinedArray.sort(function (a, b) {
          if (userDataFromStorage.user_role === "admin") {
            let currentUser = userDataFromStorage.login_name;
            let nameA = a.manager_name;
            let nameB = b.manager_name;
            if (nameA === currentUser) {
              return -1; // Current user comes before other users
            }
            if (nameB === currentUser) {
              return 1; // Other user comes before current user
            }
            // If neither name is the current user, compare them alphabetically
            return nameA.localeCompare(nameB);
          } else if (userDataFromStorage.user_role === "manager") {
            let nameA = a.agent_name.toUpperCase(); // Convert names to uppercase for case-insensitive comparison
            let nameB = b.agent_name.toUpperCase();
            if (nameA < nameB) {
              return -1; // A comes before B
            }
            if (nameA > nameB) {
              return 1; // A comes after B
            }
            return 0; // Names are equal
          }
        });

        setOverAllData(combinedArrayNew);
      }

      fetchData();
    }
  }, [
    currentData,
    currentData1,
    currentData2,
    currentData3,
    allUsers,
    agentNameForApi,
  ]);

  const handleAgentNameChange = useCallback((e) => {
    setAgentName(e.target.value);
  }, []);

  const handleManagerNameChange = useCallback((e) => {
    setManagerName(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShow.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShow.current = true;
      }

      return [];
    }
  }, [agentName, selectedAgentName]);

  const filteredManagerOptions = useMemo(() => {
    if (managerName && !selectedManagerName) {
      const searchTerm = managerName.toLowerCase();
      const optionsStartingWithSearchTerm = managerNameList.filter(
        (option) =>
          option.manager_name &&
          option.manager_name.toLowerCase().startsWith(searchTerm)
      );

      const optionsContainingSearchTerm = managerNameList.filter(
        (option) =>
          option.manager_name &&
          option.manager_name.toLowerCase().includes(searchTerm) &&
          !option.manager_name.toLowerCase().startsWith(searchTerm)
      );

      return [...optionsStartingWithSearchTerm, ...optionsContainingSearchTerm];
    } else {
      setManagerNameForApi(selectedManagerName);
      setSelectedManagerName("");

      return [];
    }
  }, [managerName]);

  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total number of pages
  useEffect(() => {
    if (overAllData.length) {
      setTotalPages(Math.ceil(overAllData.length / 20));

      // Calculate the index range for the current page
      const startIndex = (page - 1) * 20;
      const endIndex = startIndex + 20;

      // Slice the data array based on the current page
      const currentDataNew = overAllData.slice(startIndex, endIndex);
      setOverallPaginatedData(currentDataNew);
    }
  }, [overAllData, page]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[3rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[3rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.8rem] tracking-wider">
        Cash Flow Report
      </p>

      {/* Search Params */}
      <div className="bg-white  mt-[2%]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] ">
          Search Parameters
        </p>
        <div className="px-[0.5rem] mt-2">
          {userDataFromStorage.user_role === "admin" && (
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Manager Last Name</p>
              <input
                type="text"
                value={managerName}
                placeholder="Enter Manager Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleManagerNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredManagerOptions.length > 0 && (
                <div className="absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10">
                  {filteredManagerOptions.map((option) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        setSelectedManagerName(option.manager_name);
                        setManagerName(option.manager_name);
                      }}
                      key={option.manager_name}>
                      {option.manager_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {userDataFromStorage.user_role !== "senior_agent" ? (
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Agent Last Name</p>
              <input
                type="text"
                value={agentName}
                placeholder="Enter Agent Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleAgentNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredAgentOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShow.current === true
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredAgentOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        console.log("option.agent_name::", option.agent_name);
                        setAgentName(option.agent_name);
                        setSelectedAgentName(option.agent_name);
                      }}
                      key={index}>
                      {option.agent_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            ""
          )}

          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Reporting Period Starting Date</p>
            <input
              value={reportDate}
              // onChange={(e) => setReportDate(e.target.value)}
              disabled={true}
              type="date"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Reporting Period End Date</p>
            <input
              value={reportEndDate}
              onChange={(e) => setReportEndDate(e.target.value)}
              type="date"
              format="dd/mm/yyyy"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
        </div>

        <div className="flex justify-start items-center space-x-4 p-[1rem]">
          <button
            // onClick={() => filterCashHandler()}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <FiSearch />
            <p>Search</p>
          </button>
          <button
            onClick={() => {
              setAgentName("");
              setManagerName("");
              setAgentNameForApi("");
            }}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <FaUndo />
            <p>Reset</p>
          </button>
        </div>
      </div>

      {/* Report */}
      <div className="mt-8 ">
        <div className="bg-white">
          <div className="flex justify-between items-center border-[1px] px-[0.5rem] ">
            <p className="border-r-[2px] py-[0.5rem] flex-grow">
              Total Starting Cash in Hand
            </p>
            <p className="md:w-[25rem] w-[6rem] ml-2">
              MYR {totalStartingCashInHand}
            </p>
          </div>
          <div className="flex justify-between items-center border-[1px] px-[0.5rem] ">
            <p className="border-r-[2px] py-[0.5rem] flex-grow">
              Total Cash In:
            </p>
            <p className="md:w-[25rem] w-[6rem] ml-2">
              MYR {totalCashIn1.toLocaleString("en-US")}
            </p>
          </div>
          <div className="flex justify-between items-center border-[1px] px-[0.5rem] ">
            <p className="border-r-[2px] py-[0.5rem] flex-grow">
              Total Cash Out:
            </p>
            <p className="md:w-[25rem] w-[6rem] ml-2">
              MYR {totalCashOut1.toLocaleString("en-US")}
            </p>
          </div>
          <div className="flex justify-between items-center border-[1px] px-[0.5rem] ">
            <p className="border-r-[2px] py-[0.5rem] flex-grow">
              Total Claims Claims
            </p>
            <p className="md:w-[25rem] w-[6rem] ml-2">
              MYR {totalClaims1.toLocaleString("en-US")}
            </p>
          </div>
          <div className="flex justify-between items-center border-[1px] px-[0.5rem] ">
            <p className="border-r-[2px] py-[0.5rem] flex-grow">
              Total Final Cash In Hand
            </p>
            <p className="md:w-[25rem] w-[6rem] ml-2">
              MYR {totalFinalCash1.toLocaleString("en-US")}
            </p>
          </div>
        </div>
        <div className="mt-8 bg-white pb-[1.5rem]">
          <p
            style={{ backgroundColor: coloredTheme }}
            className="change-bg p-[1rem] md:w-[100%]  text-white">
            Report (Final Cash In Hand = Starting Cash In Hand + Cash In - Cash
            Out - Claims)
          </p>

          <div className="overflow-scroll px-[0.5rem] ">
            <table className="md:w-[100%] xl:w-[100%] w-[300%] ">
              <thead className="h-[6vh] ">
                <tr className="border border-gray-400 md:text-[0.9rem] xl:text-[1rem]">
                  {userDataFromStorage.user_role === "admin" && (
                    <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                      Manager{" "}
                    </th>
                  )}
                  {userDataFromStorage.user_role === "admin" ||
                  userDataFromStorage.user_role === "manager" ? (
                    <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                      Agent{" "}
                    </th>
                  ) : (
                    ""
                  )}
                  <th className="text-center border-r  border-gray-400 px-[0.2rem] w-[8rem]">
                    Cash in Hand Date{" "}
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem] w-[8rem]">
                    Starting Cash in Hand
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem] w-[8rem]">
                    Cash In
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem] w-[8rem]">
                    Cash Out
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem] w-[8rem]">
                    Claims
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem] w-[8rem]">
                    Final Cash In Hand
                  </th>
                </tr>
              </thead>
              <tbody>
                {overallPaginatedData.length
                  ? overallPaginatedData.map((x, index) => {
                      let formattedDate;

                      if (x?.cash_in_hand_date !== 0) {
                        let date = new Date(x?.cash_start_date);
                        let day = String(date?.getUTCDate()).padStart(2, "0");
                        let month = String(date?.getUTCMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        let year = String(date?.getUTCFullYear());
                        formattedDate = `${day}-${month}-${year}`;
                      }

                      return (
                        <tr
                          key={index}
                          className="border border-gray-400 md:text-[9px] xl:text-[1rem]">
                          {userDataFromStorage.user_role === "admin" && (
                            <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                              {x.manager_name}
                            </td>
                          )}
                          {userDataFromStorage.user_role === "admin" ||
                          userDataFromStorage.user_role === "manager" ? (
                            <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                              {x.agent_name}
                            </td>
                          ) : (
                            ""
                          )}
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                            {x.cash_start_date !== 0 ? formattedDate : ""}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                            <p className="whitespace-no-wrap">
                              {" "}
                              {x.cash_in_hand !== "---"
                                ? `MYR ${x?.cash_in_hand?.toLocaleString(
                                    "en-US"
                                  )}`
                                : ""}
                            </p>
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                            <p className="whitespace-no-wrap">
                              {" "}
                              {x.cash_in !== "---"
                                ? `MYR ${x?.cash_in?.toLocaleString("en-US")}`
                                : ""}
                            </p>
                          </td>

                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                            <p className="whitespace-no-wrap">
                              {" "}
                              {x.cash_out !== "---"
                                ? `MYR ${x?.cash_out?.toLocaleString("en-US")}`
                                : ""}
                            </p>
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                            <p className="whitespace-no-wrap">
                              {" "}
                              {x.claims !== "---"
                                ? `MYR ${x?.claims?.toLocaleString("en-US")}`
                                : ""}
                            </p>
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] whitespace-no-wrap">
                            <p className="whitespace-no-wrap">
                              MYR{" "}
                              {x.cash_final
                                ? x.cash_final.toLocaleString("en-US")
                                : 0}
                            </p>
                          </td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table>
          </div>
          {/* PAGINATION */}
          <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(event, newPage) => setPage(newPage)}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </div>
        </div>
        <div className="border bg-white p-[1rem]">
          <button
            style={{ backgroundColor: coloredTheme }}
            className="flex items-center justify-center px-[1rem] py-[0.5rem]  rounded space-x-2 text-white">
            <AiOutlineFileExcel />
            <p>Export Cash Flow Data to Excel</p>
          </button>
        </div>
        <div className="flex justify-end items-center space-x-2 mt-6">
          <button
            onClick={() => navigate("/home")}
            style={{ backgroundColor: coloredTheme }}
            className="flex items-center justify-center px-[1rem] py-[0.5rem]  rounded space-x-2 text-white">
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>
    </div>
  );
}

export default CashFlow;
